import { AppState } from '../../../redux/reducers';
import {
  IdentifierTypeCreateCommand,
  IdentifierTypeUpdateCommand,
  IdentifierTypeViewModel
} from '../../../models/Entities/Person/IdentifierType/IdentifierTypeModels';

// store
import * as IdentifierTypesStore from '../../../redux/middleware/PersonIdentifierTypes.Middleware';

export type IdentifierTypeSavedMode = 'created' | 'updated';

export interface IProps {
  isOpen: boolean;
  openPanel?: () => void;
  dismissPanel: () => void;
  /** Tipo a editar; sin id es un alta. */
  identifierTypeId?: number | undefined;
  /** Valores precargados del alta ("Crear CUIT"). */
  prefill?: Partial<IdentifierTypeCreateCommand>;
  /** Se llama después de guardar (el drawer ya pidió recargar la lista). */
  onSaved?: (name: string, mode: IdentifierTypeSavedMode) => void;
  /** El tipo que se editaba ya no existe (404, Persons.API spec 005): el drawer recargó la lista y se cierra. */
  onNotFound?: (name: string) => void;
}

interface ConnectedProps {
  isAdding: boolean | undefined;
  isUpdating: boolean | undefined;
  identifierType?: IdentifierTypeViewModel;
  /** Tipos cargados (para validar que el nombre no se repita). */
  existingTypes?: IdentifierTypeViewModel[];
}

interface DispatchProps {
  CreateIdentifierType: (payload: IdentifierTypeCreateCommand) => Promise<IdentifierTypeViewModel>;
  UpdateIdentifierType: (payload: IdentifierTypeUpdateCommand) => Promise<IdentifierTypeViewModel>;
  GetIdentifierTypes: () => void;
}

export type Props = IProps & ConnectedProps & DispatchProps;

export const mapStateToProps = (state: AppState, ownProps: IProps) => ({
  isAdding: state.PersonIdentifierTypes?.isAddingNewOne,
  isUpdating: state.PersonIdentifierTypes?.isUpdatingOne,
  identifierType: state.PersonIdentifierTypes?.list.find(
    (item: IdentifierTypeViewModel) => item.id === ownProps.identifierTypeId
  ),
  existingTypes: state.PersonIdentifierTypes?.list ?? [],
  ...ownProps
});

export const mapDispatchToProps = {
  CreateIdentifierType: IdentifierTypesStore.actionCreators.CreateIdentifierType,
  UpdateIdentifierType: IdentifierTypesStore.actionCreators.UpdateIdentifierType,
  GetIdentifierTypes: IdentifierTypesStore.actionCreators.GetIdentifierTypes
};
